import { render, staticRenderFns } from "./AppWechat.vue?vue&type=template&id=ec4035ee&scoped=true&"
import script from "./AppWechat.vue?vue&type=script&lang=js&"
export * from "./AppWechat.vue?vue&type=script&lang=js&"
import style0 from "./AppWechat.vue?vue&type=style&index=0&id=ec4035ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4035ee",
  null
  
)

export default component.exports